import { useContext } from "react";
import CarrierActivityReloadContext from "../CarrierActivityReloadContext";

const useReloadCarrierActivities = () =>
  useContext(CarrierActivityReloadContext);

export default useReloadCarrierActivities;
